import { useMemo } from "react";
import styles from "./Tooltip.module.css";
import TooltipImg from "public/icons/Tooltip.svg";

export interface ITooltipProps {
  text: string;
  className?: string;
}

const Tooltip = ({
  text,
  className,
}: ITooltipProps) => {

  const _className = useMemo(() => (
    [
      styles.root,
      className,
    ].filter(x => x !== undefined).join(" ")
  ), [className]);

  return (
    <div className={_className}>
      <img src={TooltipImg.src} alt="tooltip" />
      <div className={styles.tooltip} dangerouslySetInnerHTML={{ __html: text }}>
      </div>
    </div>
  );
};

export default Tooltip;
